import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material'
import { DownloadCloud } from 'react-feather'

import { CustomAutocomplete, CustomLoading, FileManagerInput } from 'common'

const acceptConfiguration = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp']
}

export const FormMovementBank = ({ useFetchInit }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Helpers,
        Actions
    } = useFetchInit

    const { loadingSubmitForm, modalOpeningMode } = globalStates
    const readOnly = modalOpeningMode === 'READONLY'
    const fieldVariant = readOnly ? 'filled' : 'outlined'

    const { FormMovement } = Forms
    const {
        formState, onInputChange, onSelectSearchChange,
        onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange
    } = FormMovement

    const { fetchAllBanks } = FetchData
    const { banks } = fetchAllBanks

    const { formatMoney } = Helpers

    const {
        onSubmitMovementForm,
        handleChangeMovementAmount,
        handleChangeMovementCurrency,
        handleChangeMovementExchangeRate,
        handleClickHideMovementForm,
        handleClickDownloadBoleta
    } = Actions

    const bankOptions = readOnly ? banks : banks.filter(b => Number(b.estado) === 1)
    const selectedBank = banks.find(b => Number(b.idbanco) === Number(formState.idbanco))

    const currencyMismatch = Boolean(
        !readOnly && selectedBank && formState.movimiento_moneda && selectedBank.currency_type !== formState.movimiento_moneda
    )

    const bankBalance = selectedBank
        ? (selectedBank.currency_type === 'DOLAR'
            ? `$ ${formatMoney(selectedBank.saldo_dolares)}`
            : `Q. ${formatMoney(selectedBank.saldo_quetzales)}`)
        : ''

    return (
        <div className='content'>
            <Card style={{ zIndex: '1' }}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>{readOnly ? 'Información de Registro' : 'Crear Registro'}</div>
                    <div className="border-bottom border-dark"></div>

                    <div className="pt-3"></div>
                    {!readOnly && (<p className='text-danger'>* campos obligatorios</p>)}
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitMovementForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_fecha">* Fecha de registro</label>
                                    <TextField
                                        id='movimiento_fecha'
                                        name='movimiento_fecha'
                                        value={formState.movimiento_fecha}
                                        size='small'
                                        placeholder='Fecha de registro'
                                        type='date'
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ readOnly: true }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_tipo">* Tipo</label>
                                    <TextField
                                        id="movimiento_tipo"
                                        name="movimiento_tipo"
                                        value={formState.movimiento_tipo}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        variant={fieldVariant}
                                        hiddenLabel
                                        InputProps={{ readOnly }}
                                        required
                                    >
                                        <MenuItem value='INGRESO'>INGRESO</MenuItem>
                                        <MenuItem value='EGRESO'>EGRESO</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="idbanco">* Banco</label>
                                    <CustomAutocomplete
                                        customId="idbanco"
                                        customName="idbanco"
                                        customValue={formState.idbanco}
                                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idbanco', value: value.value } })}
                                        customPlaceholder='Seleccionar banco'
                                        customOptions={
                                            bankOptions.map(({ idbanco, nombre }) => ({
                                                value: idbanco,
                                                name: nombre
                                            }))
                                        }
                                        customDisableClearable={true}
                                        customDisabled={readOnly}
                                    />
                                </FormControl>
                                {!readOnly && selectedBank && (
                                    <small className='text-muted'>
                                        Moneda del banco: <b>{selectedBank.currency_type}</b> · Saldo: <b>{bankBalance}</b>
                                    </small>
                                )}
                            </Grid>
                        </Grid>

                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_monto">* Monto</label>
                                    <TextField
                                        id="movimiento_monto"
                                        name="movimiento_monto"
                                        value={formState.movimiento_monto}
                                        onChange={handleChangeMovementAmount}
                                        size='small'
                                        type="text"
                                        variant={fieldVariant}
                                        hiddenLabel
                                        InputProps={{ readOnly }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_moneda">* Moneda</label>
                                    <TextField
                                        id="movimiento_moneda"
                                        name="movimiento_moneda"
                                        value={formState.movimiento_moneda}
                                        onChange={handleChangeMovementCurrency}
                                        select
                                        size="small"
                                        variant={fieldVariant}
                                        hiddenLabel
                                        InputProps={{ readOnly }}
                                        error={currencyMismatch}
                                        required
                                    >
                                        <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                        <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_tipo_cambio">* Tipo de Cambio</label>
                                    <TextField
                                        id="movimiento_tipo_cambio"
                                        name="movimiento_tipo_cambio"
                                        value={formState.movimiento_tipo_cambio}
                                        onChange={handleChangeMovementExchangeRate}
                                        size='small'
                                        type="text"
                                        variant={fieldVariant}
                                        hiddenLabel
                                        InputProps={{ readOnly }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        {currencyMismatch && (
                            <p className='text-danger mt-2 mb-0'>
                                El banco seleccionado solo admite transacciones en {selectedBank.currency_type}. Seleccione otro banco o cambie la moneda de la transacción.
                            </p>
                        )}

                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_quetzales">* Total en Quetzales</label>
                                    <TextField
                                        id="movimiento_quetzales"
                                        name="movimiento_quetzales"
                                        value={formState.movimiento_quetzales}
                                        size='small'
                                        type="text"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ readOnly: true }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_dolares">* Total en Dolares</label>
                                    <TextField
                                        id="movimiento_dolares"
                                        name="movimiento_dolares"
                                        value={formState.movimiento_dolares}
                                        size='small'
                                        type="text"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ readOnly: true }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="boleta_numero">* Boleta #</label>
                                    <TextField
                                        id="boleta_numero"
                                        name="boleta_numero"
                                        value={formState.boleta_numero}
                                        onChange={onInputChange}
                                        size='small'
                                        variant={fieldVariant}
                                        hiddenLabel
                                        inputProps={{ maxLength: 40 }}
                                        InputProps={{ readOnly }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="aprobacion_referencia_ach">No. Referencia ACH</label>
                                    <TextField
                                        id="aprobacion_referencia_ach"
                                        name="aprobacion_referencia_ach"
                                        value={formState.aprobacion_referencia_ach}
                                        onChange={onInputChange}
                                        size='small'
                                        variant={fieldVariant}
                                        hiddenLabel
                                        inputProps={{ maxLength: 100 }}
                                        InputProps={{ readOnly }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                {!readOnly && (
                                    <FormControl fullWidth>
                                        <label htmlFor="images">* Boleta de Depósito</label>
                                        <FileManagerInput
                                            acceptedFiles={formState.acceptedFiles}
                                            fileRejections={formState.fileRejections}
                                            NameId='images'
                                            typeFiles='IMG'
                                            maxFiles={1}
                                            accept={acceptConfiguration}
                                            setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                            setFileRejections={onDropZoneRejectionsFilesChange}
                                        />
                                    </FormControl>
                                )}
                                {readOnly && (
                                    <FormControl>
                                        <label>Boleta de Depósito</label>
                                        <Button
                                            startIcon={<DownloadCloud />}
                                            color='success'
                                            variant='contained'
                                            onClick={() => handleClickDownloadBoleta(formState.boleta_foto_originalname, formState.boleta_foto_path)}
                                            disabled={!formState.boleta_foto_path}
                                            sx={{ textDecoration: 'none', paddingTop: 1 }}
                                        >
                                            Descargar
                                        </Button>
                                    </FormControl>
                                )}
                            </Grid>
                        </Grid>

                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_observaciones">* Observaciones</label>
                                    <TextField
                                        id="movimiento_observaciones"
                                        name="movimiento_observaciones"
                                        value={formState.movimiento_observaciones}
                                        onChange={onInputChange}
                                        size='small'
                                        multiline
                                        rows={3}
                                        type="text"
                                        variant={fieldVariant}
                                        inputProps={{ maxLength: 500 }}
                                        InputProps={{ readOnly }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        {loadingSubmitForm && (<CustomLoading />)}
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{ background: "#4b4b4c" }}
                                        variant="contained"
                                        type='submit'
                                        disabled={readOnly || loadingSubmitForm || currencyMismatch}
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideMovementForm}
                                        disabled={loadingSubmitForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; {readOnly ? 'Volver' : 'Cancelar'}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
